import { useEffect } from "react";

export default function useDarkLayout() {
    useEffect(() => {
        window.document.body.classList.add('dark-lib');

        return () => {
            window.document.body.classList.remove('dark-lib');
        }
    });
}
